/**
 * Chart color constants
 * Used across all analytics charts for consistent styling
 */

// Bar chart color (purple)
export const CHART_BAR_COLOR = '#B68AFF';

// Line chart color (yellow/gold)
export const CHART_LINE_COLOR = '#FFBF00';
